export default {"src":"/_next/static/media/loading.39653058.svg","height":203,"width":203,"blurWidth":0,"blurHeight":0};